const theme = {
  colors: {
    greenDefault: "#ADFF2F",
    greenWit: "#ABE523",
    blackDefault: "#2B3137",
    defaultLabel: "#33393d"
  },
  font: {
    fontSizeDefault: "1em"
  }
};

export default theme;
